import * as React from "react";
import { useNavigate } from "react-router-dom";
import { TenantImage } from "@/components/Images/TenantImage";
import { NavMain } from "@/components/nav-main";
import { NavSuperAdmin } from "@/components/nav-super-admin";
import { ThemeToggle } from "@/components/theme-toggle";
import {
    Sidebar,
    SidebarContent,
    SidebarFooter,
    SidebarHeader,
    SidebarMenu,
    SidebarMenuButton,
    SidebarMenuItem,
    useSidebar,
} from "@/components/ui/sidebar";
import { useAppSelector } from "@/hooks/types";
import { usePortalPermissions } from "@/hooks/usePortalPermissions";
import { getTenant } from "@/store/tenant/selectors";

export const AppSidebar = ({
    ...props
}: React.ComponentProps<typeof Sidebar>) => {
    const { canAccessSuperAdminFeatures, canAccessPortal } =
        usePortalPermissions();
    const { state } = useSidebar();
    const navigate = useNavigate();
    const tenant = useAppSelector(getTenant);
    return (
        <Sidebar
            collapsible="icon"
            {...props}
        >
            <SidebarHeader>
                <SidebarMenu>
                    <SidebarMenuItem>
                        <SidebarMenuButton
                            className="data-[slot=sidebar-menu-button]:!p-1.5"
                            onClick={() => {
                                navigate("/");
                            }}
                        >
                            {state !== "collapsed" ? (
                                <span className="text-admin-primary text-lg font-bold">
                                    {tenant?.name}
                                </span>
                            ) : (
                                <span className="text-admin-primary text-lg font-bold">
                                    {tenant?.name.slice(0, 1)}
                                </span>
                            )}
                        </SidebarMenuButton>
                    </SidebarMenuItem>
                </SidebarMenu>
            </SidebarHeader>
            <SidebarContent>
                {canAccessPortal && <NavMain />}
                {canAccessSuperAdminFeatures && <NavSuperAdmin />}
            </SidebarContent>
            <SidebarFooter>
                <ThemeToggle />
            </SidebarFooter>
        </Sidebar>
    );
};
